<template>
    <span v-if="siloData.user.id !== 0" id="topicsmenu" class="card" :data-state="state" ref="parent" :data-is-covered="isCovered" :data-scrolled="scrolled">
        <div class="card__mover" :style="`transition-duration: ${loadModule}`">
            <div class="card__container">
                <div class="swipecloser"
                    @touchstart="onTouchStart"
                    @touchmove="onTouchMove"
                    @touchend="onTouchEnd"
                ></div>
                <div class="card__breadcrumb">
                    <EntryHeaderCard :title="entryHeaderTitle" :scrolled="scrolled" @close="close()" />
                </div>
                <div class="ms ms--regular" ref="scroller" @scroll="checkScroll">
                    <div class="ms__wrap c c--content--pad r pad--h v--20">

                        <div v-if="modules !== null" class="ms__top topic-intro r v--10">
                            <h1 class="topic-intro__title type--h2--default" v-html="args.title ? args.title : topic.title"></h1>
                            <div class="topic-intro__image" :class="topic.lesson_image ? 'topic-intro__image--image' : 'topic-intro__image--blank'">
                                <IconDynamic v-if="topic.lesson_image" :name="`sp/lesson/${topic.lesson_image}`" />
                                <transition name="fade-slide-y" mode="out-in">
                                    <div v-show="checkTopicComplete() === true" class="topic-intro__complete">
                                        <Icon :name="`topic-complete`" />
                                    </div>
                                </transition>
                            </div>
                            <p v-if="args.hide_description !== true" class="topic-intro__count type--p--small">Complete all <span
                                    v-text="lessons_count"></span> lessons to move on to the next topic area.</p>
                        </div>


                            <div class="lessons">
                                <div v-for="(mod, index) in lessons"
                                    :key="mod.slug"
                                    class="lesson r"
                                    :class="{ 'lesson--show': showLessons }"
                                    :style="{ animationDelay: animationDelay(index) }"
                                    :data-module="(index + 1)"
                                    :data-status="getLessonStatus(topic.menu_order, index)"
                                    :data-locked="isLessonLocked(topic.menu_order, index)"
                                    :data-is-first="(index === 0 ? 'true' : 'false')">
                                    <button @click="openModule(mod.slug)" class="lesson__button" :title="mod.title_override ? mod.title_override : mod.title">
                                        <div class="lesson__button__icon">
                                            <Icon :name="`icons/lesson-${mod.lesson_type}`" />
                                        </div>
                                        <h3 class="lesson__button__title type--h3--card" v-html="mod.title_override ? mod.title_override : mod.title"></h3>
                                        <div v-if="args.hide_status !== true" class="lesson__button__status">
                                            <Icon name="sp/ui/status-complete" />
                                        </div>
                                    </button>
                                    <!--
                                    <div v-if="index !== modules.length - 1" class="topic__progress"></div>
                                    -->
                                </div>
                                <transition name="fade-slide-y" mode="out-in">
                                    <div v-show="checkTopicComplete() === true" class="topic-complete c r pad--h">
                                        <div class="topic-complete__wrap r">
                                            <button class="btn btn--solid" @click="close">Close Topic</button>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                    </div>
                </div>
            </div>
            <div class="ms__bg"></div>
        </div>
    </span>
</template>

<script>
import { ToWords } from 'to-words';
const toWords = new ToWords();

import Icon from "@c/Icon.vue"
import IconDynamic from "@c/IconDynamic.vue"
import Loading from "@c/Loading.vue"
import EntryHeaderCard from '@c/EntryHeaderCard.vue'
const axios = require('axios');
export default {
    components: {
        EntryHeaderCard,
        Icon,
        Loading,
        IconDynamic,
    },
    data() {
        return {
            modules: null,
            topic_slug: null,
            state: "inactive",
            scrolled: false,
            anims: {
                loadModuleJS: 550,
            },
            args: {
                title: null,
                description: null,
                hide_description: false,
                hide_status: false,
            },
            initial_args: {},
            startY: 0,
            endY: 0,
            minSwipeDistance: 60, // px, tweak as needed
            showLessons: false,
            baseDelay: 0.075,
            stagger: 0.05,
        }
    },
    computed: {
        loadModule() {
            return `${this.anims.loadModuleJS}ms`;
        },
        topic() {
            return this.modules !== null ? this.modules[0] : null;
        },
        lessons() {
            return this.modules !== null ? this.modules.slice(1) : null;
        },
        lessons_count() {
            return this.modules !== null ? toWords.convert(this.lessons.length) : 0;
        },
        isCovered() {
            return this.appState === 'module' || this.appState === 'module-intro' ? 'true' : 'false';
        },
        entryHeaderTitle() {
            let returned_title = this.topic ? this.topic.title : '';
            if (this.args.title) {
                returned_title = this.args.title;
            }
            return returned_title;
        },
        isTopicComplete() {
            if (this.topic === null) { return false; }
            if (this.modules === null) { return false; }

            const topic_id = this.topic.menu_order;

            return this.siloData.user.progress[topic_id].status === "complete" ? true : false;
        },
    },
    props: {
        siloData: Object,
        appState: String,
        activator: String,
        hasChildren: Boolean, // not sure i need this
        processing: Boolean,
    },
    created() {
        this.copyArgs();
    },
    mounted() {
        window.topicmenu = this;
        this.checkForCardQueryString();
    },
    methods: {
        // This is how you do this, otherwise it links the two together and erases the original
        copyArgs() {
            this.initial_args = { ...this.args };
        },
        resetArgs() {
            this.args = { ...this.initial_args };
        },
        setArgs(new_args) {
            const updated_args = this.mergeArgs(this.args, new_args);
            this.args = { ...updated_args };
        },
        mergeArgs(args, new_args) {
            return {
                ...args,
                ...new_args
            };
        },
        checkForCardQueryString() {
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('topic')) {
                this.getTopicMenu(urlParams.get('topic'));
            }
        },
        checkForLessonQueryString() {
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('lesson')) {
                this.openModule(urlParams.get('lesson'))
            }
        },
        updateUrl(string = "") {
            console.log('UPDATING URL');
            var url = new URL(window.location);
            if (string !== "") {
                console.log('STRING IS NOT BLANK');
                //url.searchParams.set('pg', this.activator);
                if (this.topic_slug !== null) {
                    url.searchParams.set('topic', this.topic_slug);
                    if (url.searchParams.get('lesson')) {
                        url.searchParams.set('lesson', url.searchParams.get('lesson'));
                    }
                }
            } else {
                console.log('STRING IS BLANK');
                url.searchParams.delete('topic');
            }

            window.history.pushState({}, '', url);
        },
        open() {
            console.log('*********************************** OPENENING TOPIC');
            this.resetScroll();
            this.state = 'active';
            this.$emit('updateState', 'topic');

            setTimeout(() => {
                console.log('*********************************** animating topics');
                this.$nextTick(() => {
                    this.showLessons = true
                });
                setTimeout(() => {
                    // Check for modules
                    this.checkForLessonQueryString();
                }, 1);
            }, 1);

            // Set the url
            this.updateUrl(this.activator);

            // trigger view event
            this.postPageView();
        },
        close() {
            this.state = 'inactive';

            // I think I probably need to update the state here
            this.$emit('updateState', 'home');

            // Clear data
            this.module = null;
            this.topic_slug = null;
            this.showLessons = false;

            // Clear the url
            this.updateUrl();
        },
        // Not quitting back to homescreen
        close_soft() {
            this.state = 'inactive';
        },
        setProcessing(state) {
            console.log('setting processing (module slide)');
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            console.log('refreshing data (module slide)');
            this.$emit('refreshData', onComplete);
        },
        getLessonStatus(topic_index, lesson_index) {
            //console.log('lesson status', `topic ${topic_index}, lesson ${lesson_index}`);
            return this.siloData.user.progress[topic_index].lessons[lesson_index] ? this.siloData.user.progress[topic_index].lessons[lesson_index] : "open";
        },
        isLessonLocked(topic_index, lesson_index) {
            // First one is always open
            if (lesson_index === 0) {
                return "false";
            } else {
                // If this is a module greater than 1
                // Look at the user's status table
                // and check the previous index to see if it is completed
                let previous_module_status = this.siloData.user.progress[topic_index].lessons[lesson_index - 1];

                // If the previous module is complete, this module is unlocked
                if (previous_module_status === "complete") {
                    return "false"
                } else {
                    return "true"
                }
            }
        },
        async getTopicMenu(id, new_args = null) {

            // Reset args back to initial state
            this.resetArgs();

            if (new_args !== null) {
                this.setArgs(new_args);
            }

            axios.post(this.siloData.urls.gettopicmenu, { id: id }).then((result) => {
                //console.log(JSON.parse(JSON.stringify(result.data)));
                this.topic_slug = id;
                this.modules = result.data;
                this.open();
            }).catch((reason) => {
                console.log(reason);
            });
        },
        openModule(id) {

            // We need to clear out any query strings, otherwise when we open the URL
            // it will make the modal act strange
            // MIGHT NEEDS THIS, BUT NOT SURE?
            // this.clearQueryStrings();


            // You need the full url path with the topic parent to get JUST the children of the topic
            const fullslug = `${this.topic.slug}/${id}`;

            console.log('%%% trying to open module: ', fullslug);

            // If there is an override title, pass it in, this manages the entry header title on the slides
            const title_override = this.args.title ? this.args.title : null;


            // True allows this to open with a slug
            // MAYBE OPEN THIS WITH THE TOPIC AND LESSON AS WELL?
            window.moduleloader.open(fullslug, true, title_override);

            // module loader needs events
            // module loading = screen loading
            // module loaded = hide menu
            // this.close_soft();
            // ! THIS CLOSES ITSELF IN A WATCH FUNCTION
        },
        clearQueryStrings() {

            // Get the current url without query strings
            let cleanUrl = window.location.href.replace(window.location.search, '');

            // Update the URL without reloading
            window.history.replaceState({}, window.title, cleanUrl);

        },
        postPageView() {
            let data = {
                type: 'open',
                message: 'Viewed Topic:' + ` ${this.entryHeaderTitle}`,
            };
            window.events.postPageView(data);
        },
        // Check to see if we've scrolled in the parent frame
        checkScroll() {
            if (this.$refs.parent === undefined) { return; }

            // 88 is the height of the header area
            if (this.$refs.scroller.scrollTop > 35) {
                this.scrolled = true;
            } else {
                this.scrolled = false;
             };
       },
       // Reset the scroll back to 0
       resetScroll() {
            this.$refs.scroller.scrollTop = 0;
       },
        onTouchStart(e) {
            this.startY = e.touches[0].clientY
        },
        onTouchMove(e) {
            this.endY = e.touches[0].clientY
        },
        onTouchEnd() {
            const distance = this.endY - this.startY

            if (distance > this.minSwipeDistance) {
                this.close()
            }

            // reset
            this.startY = 0
            this.endY = 0
        },
        animationDelay(index) {
            return `${this.baseDelay + index * this.stagger}s`
        },
        checkTopicComplete() {
            if (this.topic === null) { return false; }
            if (this.modules === null) { return false; }

            const topic_id = this.topic.menu_order;

            return this.siloData.user.progress[topic_id].status === "complete" ? true : false;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

#topicsmenu {
    transition: all 0.5s;
    .ms__bg, .card__container {
        transition: all 0.5s;
    }
    &[data-is-covered="false"] {
        transform: scale(1);
        .card__container {
            opacity: 1;
            //transform: scale(1);
        }
    }
    &[data-is-covered="true"] {
            //opacity: 0.25;
            transform: scale(0.95);
        .ms__bg {
            background-color: var(--color-offwhite-dark) !important;
        }
        .card__container {
            opacity: 0.25;
            //transform: scale(0.95);
        }
    }
    .card__container {
        overflow: inherit !important;
    }
    &[data-scrolled="true"] {
        .ms__wrap {
            &:before {
                opacity: 1;
            }
        }
    }
}

.card {
    display: flex;
    position: fixed;
    top: var(--padding-top-card);
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: $z_top;

    >* {
        width: 100%;
        transition-property: all;
        transition-timing-function: $easing_regular;
        transform: translateY(100%);
    }

    &[data-state="active"] {
        pointer-events: inherit;

        >* {
            transform: translateY(0);
        }
    }
}

.card__container {
    height: 100%;
    transition: all 0.15s;
}

.ms {
    padding-top: 0 !important;
    //padding-top: rem(20px);

}

.ms__wrap {
    padding-bottom: rem(120px);
    transition: all 0.5s;
        &:before {
        content: "";
        display: block;
        width: 100%;
        height: rem(10px);
        //background: #095656;
        background:     radial-gradient(
            farthest-side at 50% 0,
            rgba(var(--color-sp-emerald-rgb), 0.2),
            rgba(var(--color-sp-emerald-rgb), 0),
            ) center top;
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
        opacity: 0;
        transition: opacity 0.15s;
        z-index: 2;
    }
}

.card__breadcrumb {
    transition: all 0.5s;
}

.ms__loading {
    margin-top: rem(50px);
}

.topic {
    opacity: 0;
}

.topic__wrap {
    gap: rem(20px);
    justify-content: center;
    align-items: center;
}

.topic__status {
    display: flex;
    flex-direction: center;
    align-items: center;
}

.topic__status__icon {
    width: rem(33px);
    height: rem(33px);
    border-radius: 100%;
    border: 1px solid var(--color-dark-grey);
    z-index: 2;
    background-color: var(--color-white);
}

.topic__button {
    background-color: var(--color-light-grey);
    border-radius: rem(8px);
    gap: rem(15px);
    padding: rem(12px) rem(20px);
    flex-direction: row;
    justify-content: space-between;

    &:hover,
    &:focus {
        background-color: var(--color-medium-light-grey);
    }
}

.topic__button__title {
    text-align: left;
}

.topic__button__image {
    // ! update this when I get an image
    height: 49px;
    width: 90px;
    overflow: hidden;

    //border-radius: 8px;
    //background-color: var(--color-dark-grey);
    >* {
        width: 100%;
        height: auto;
    }
}

.topic[data-locked="true"] {
    .topic__status__icon {
        background-color: #bdbdbd;
        border-color: #bdbdbd;
    }

    button {
        pointer-events: none;
    }

    .topic__button {
        pointer-events: none;
        opacity: 0.5;

        svg {
            filter: grayscale(0);
        }
    }
}

.topic__progress {
    width: 2px;
    height: 70px;
    background-color: var(--color-light-grey);
    position: absolute;
    left: 15px;
    top: 49px;
    z-index: 1;
    opacity: 0.5;
}

.topic[data-status="complete"] {
    .topic__status__icon {
        background-image: svg-url($icon_topic_complete);
        background-size: cover;
        border-color: var(--color-navy-blue) !important;
    }

    .topic__progress {
        background-color: var(--color-grey);
    }
}

[data-processing="true"] {}

.ms__bg {
    background-color: var(--color-offwhite);
    border-top-left-radius: rem(24px);
    border-top-right-radius: rem(24px);
}

/* new ------------------------------------------------------ */

.topic-intro {}

.topic-intro__title {
    text-align: center;
}

.topic-intro__image {
    width: 100%;
    height: 100%;
    aspect-ratio: 326/170;
    border-radius: rem(10px);
    margin-top: rem(22px);
    svg {
        width: 100%;
        height: auto;
    }
    &--blank {
        background-color: var(--color-sp-teal);
    }
}

.topic-intro__count {
    margin-top: rem(17px);
    span {
        text-transform: lowercase;
    }
}

/* Lessons ------------------------------------------------------ */

.lessons {
    display: flex;
    flex-direction: column;
    gap: rem(10px);
    padding-bottom: rem(90px);
}



.lesson__button {
    background-color: var(--color-sp-stardust);
    padding: rem(15px) rem(10px);
    width: 100%;
    border-radius: rem(20px);
    flex-direction: row;
    align-items: center;
    gap: rem(11px);
    display: flex;
    border-radius: rem(5px);
    transition: all 0.15s;

    &:hover,
    &:focus,
    &:active {
        outline: 1px solid var(--color-sp-jade);
    }
}

.lesson__button__icon {
    display: flex;
    flex-shrink: 0;
    width: rem(23px);
    height: rem(22px);
    justify-content: center;
    align-items: center;
    > * {
        width: 100%;
        height: auto;
    }
}

.lesson__button__title {}

/* topci complete ------------------------------------------------------ */

.topic-complete {
    padding-top: rem(30px);
    > * {
        button {
            margin-inline: auto;
        }
    }
}

</style>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.lesson__button__status {
    width: rem(27px);
    height: rem(26px);
    display: block;
    position: absolute;
    right: rem(15px);
    opacity: 0;
    transform: scale(0) rotate(180deg);
    transition: all 0.3s 0.1s;
    svg {
        width: 100%;
        height: auto;
    }
}

.lesson {
      opacity: 0;
  transform: translateY(50px);
    &[data-status="open"] {

    }
    &[data-locked="true"] {
        opacity: 0.4 !important;
        pointer-events: none !important;
    }
    &[data-status="complete"] {
        .lesson__button__status {
            opacity: 1;
            transform: scale(1) rotate(0deg);
        }
    }
}

.lesson--show {
  animation: lessonEnter 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

@keyframes lessonEnter {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-slide-y-enter-active,
.fade-slide-y-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-y-enter {
  opacity: 0;
  transform: translateY(10px); /* starts slightly right */
}

.fade-slide-y-leave-to {
  opacity: 0;
  transform: translateY(-10px); /* exits to the left */
}

.topic-intro__complete {
    position: absolute;
    top: rem(20px);
    right: rem(22px);
    z-index: 2;
    width: rem(54px);
    height: rem(57px);
}
</style>